export default __webpack_public_path__ + "d478a274214dd2a67ae7575ba6cd1568.svg";